import { create } from "zustand";

/**
 * 音量・ミュート・モバイル案内の既読・語りの速さ・動きを抑える設定を保持するストア。
 * 更新頻度はまれ。BGM は既定ミュート（`muted: true`）。
 *
 * NFR-002 のための規則: 利用側はストア全体ではなくセレクタで必要な値のみを購読すること。
 */
export interface UiStore {
  readonly volume: number;
  readonly muted: boolean;
  readonly mobileGuideAcknowledged: boolean;
  /** 語り（ADVのテキスト送り）の速さ倍率。既定`1`。文字送り20ms/字にこの逆数を掛けて使う。 */
  readonly narrationSpeedMultiplier: number;
  /** OSの`prefers-reduced-motion`に加えた、手動での動き抑制の上書き。既定`false`。 */
  readonly reduceMotionOverride: boolean;
  readonly setVolume: (volume: number) => void;
  readonly setMuted: (muted: boolean) => void;
  readonly setMobileGuideAcknowledged: (acknowledged: boolean) => void;
  readonly setNarrationSpeedMultiplier: (multiplier: number) => void;
  readonly setReduceMotionOverride: (override: boolean) => void;
}

export const useUiStore = create<UiStore>((set) => ({
  volume: 1,
  muted: true,
  mobileGuideAcknowledged: false,
  narrationSpeedMultiplier: 1,
  reduceMotionOverride: false,
  setVolume: (volume) => set({ volume }),
  setMuted: (muted) => set({ muted }),
  setMobileGuideAcknowledged: (acknowledged) => set({ mobileGuideAcknowledged: acknowledged }),
  setNarrationSpeedMultiplier: (multiplier) => set({ narrationSpeedMultiplier: multiplier }),
  setReduceMotionOverride: (override) => set({ reduceMotionOverride: override }),
}));
